import { useEffect, useState } from "react"
import * as serviceWorkerRegistration from "serviceWorkerRegistration"

// Surfaces a waiting service worker (a new deploy already downloaded in the
// background) instead of silently sitting on it until every tab is closed.
// Reload is left to the user rather than forced — this app is meant to stay
// open through a whole set, and an unannounced reload would cut off
// whatever's playing.
export default function useServiceWorkerUpdate() {
  const [waitingRegistration, setWaitingRegistration] = useState(null)

  useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdate: (registration) => setWaitingRegistration(registration)
    })
  }, [])

  const reloadForUpdate = () => {
    const worker = waitingRegistration?.waiting
    if (!worker) return

    navigator.serviceWorker.oncontrollerchange = () => window.location.reload()
    worker.postMessage({ type: "SKIP_WAITING" })
  }

  return { updateAvailable: Boolean(waitingRegistration), reloadForUpdate }
}
